module.exports = __webpack_public_path__ + "assets/3f2e589aca835f5e9c4a7a72d2276923.svg";